import Enumerator from '../global/Enumerator';

export const contactSourceOfWealths = [
  'none',
  'salary_or_wages',
  'dividends_or_income_from_business',
  'divorce_settlement',
  'family_trust_or_inheritance',
  'donation_or_gift',
  'grant_or_subsidy',
  'insurance_or_settlement_proceeds',
  'investment_income',
  'lottery_or_gambling',
  'pension_or_social_benefits_payments',
  'royalties',
  'sale_of_property_or_investments',
  'spouse_or_partner',
  'other'
];

export class ContactSourceOfWealth extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
        correctOption = 'salary_or_wages';
        break;
      case '2':
        correctOption = 'dividends_or_income_from_business';
        break;
      case '3':
        correctOption = 'divorce_settlement';
        break;
      case '4':
        correctOption = 'family_trust_or_inheritance';
        break;
      case '5':
        correctOption = 'donation_or_gift';
        break;
      case '6':
        correctOption = 'grant_or_subsidy';
        break;
      case '7':
        correctOption = 'insurance_or_settlement_proceeds';
        break;
      case '8':
        correctOption = 'investment_income';
        break;
      case '9':
        correctOption = 'lottery_or_gambling';
        break;
      case '10':
        correctOption = 'pension_or_social_benefits_payments';
        break;
      case '11':
        correctOption = 'royalties';
        break;
      case '12':
        correctOption = 'sale_of_property_or_investments';
        break;
      case '13':
        correctOption = 'spouse_or_partner';
        break;
      case '14':
        correctOption = 'other';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

ContactSourceOfWealth.initEnum({
  none: {
    get title() {
      return 'Select one';
    }
  },
  salary_or_wages: {
    get title() {
      return 'Salary/Wages';
    }
  },
  dividends_or_income_from_business: {
    get title() {
      return 'Dividends or income from business';
    }
  },
  divorce_settlement: {
    get title() {
      return 'Divorce settlement';
    }
  },
  family_trust_or_inheritance: {
    get title() {
      return 'Family trust/Inheritance';
    }
  },
  donation_or_gift: {
    get title() {
      return 'Donation/Gift';
    }
  },
  grant_or_subsidy: {
    get title() {
      return 'Grant/Subsidy';
    }
  },
  insurance_or_settlement_proceeds: {
    get title() {
      return 'Insurance/Settlement proceeds';
    }
  },
  investment_income: {
    get title() {
      return 'Investment income';
    }
  },
  lottery_or_gambling: {
    get title() {
      return 'Lottery/Gambling';
    }
  },
  pension_or_social_benefits_payments: {
    get title() {
      return 'Pension/Social benefits payment(s)';
    }
  },
  royalties: {
    get title() {
      return 'Royalties';
    }
  },
  sale_of_property_or_investments: {
    get title() {
      return 'Sale of property or investments';
    }
  },
  spouse_or_partner: {
    get title() {
      return 'Spouse/Partner';
    }
  },
  other: {
    get title() {
      return 'Other';
    }
  }
});

export default {
  contactSourceOfWealths,
  ContactSourceOfWealth
};
